<template>
    <div class="wrap" style="z-index: 102;">
        <!-- 03_로그인 02_이메일popup -->
        <div class="modal show" >
            <div class="modal_box">
                <p class="modal_title">
                    {{ store.getters.getUserInfoModalContent }}
                </p>
                <div class="modal_btnbox">
                    <button type="button" class="modal_close btn" @click="closeModal">확인</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { useStore } from 'vuex';
const store = useStore();
const closeModal = () => {
    store.commit('setUserInfoModalState', false);
}
</script>